import React from 'react';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { useSelector } from 'react-redux';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import styles from '../base/CommonSettings.module.scss';
import NumberInput from '../../../common/NumberInput.jsx';
import CommonSlider from '../../../common/CommonSlider.jsx';
import Select from '../../../common/Select.jsx';
import { FONT_FAMILY_TYPE } from '../schemaHelpers.js';
import AlignmentSettings from '../../settings_sidebar/AlignmentSettings.jsx';
import DashboardColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';

export const DEFAULT_FONT_SIZE = {
  content_title: 30,
  subtitle: 16
}

// Because the RichTextEditor is setup so that it will only updateAnswer onBlur so only when user click out of the editor it will update
function TitleWidgetSettings({ widgetId }) {
    return(
        <>
          <CollapsibleSection title={I18n.t('content_settings')}>
              <SectionConfig enableToggle={false} widgetId={widgetId} name='content_title' />
              <hr />
              <SectionConfig enableToggle={true} widgetId={widgetId} name='subtitle' />
              <hr />
              <AlignmentSettings widgetId={widgetId} />
          </CollapsibleSection>
        </>
    )
}

function SectionConfig({name, widgetId, enableToggle}){
  const setAttribute = useSetWidgetAttribute(widgetId);
  const attrs = useSelector(state => state.dashboard.widgets[widgetId]?.settings?.[name]) || {};
  return (
    <CollapsibleSection 
      title={I18n.t(name)}
      enableToggle={enableToggle}
      defaultEnabled={attrs.enabled === null || attrs.enabled}
      onToggleEnabled={(v) => setAttribute(`settings.${name}.enabled`, v)}
    >
    <div className={`${styles['settings-option']} mb-1`} >
      <label className="w-100">{I18n.t('text')}</label>
      <textarea
        value={attrs.text || ''}
        className='mr-1 form-control'
        onChange={(e) => setAttribute(`settings.${name}.text`, e.target.value)}
      />
    </div>
    <div className={`${styles['settings-option']} mb-1`} >
      <label className='w-100'>{I18n.t('text_color')}</label>
      <DashboardColorPicker value={attrs.color} onChange={(value) => setAttribute(`settings.${name}.color`, value)} />
    </div>
    <div className={`${styles['settings-option']} mb-1`} >
      <label className="w-100">{I18n.t("font_size")}</label>
      <CommonSlider value={attrs.fontSize || DEFAULT_FONT_SIZE[name]} min={8} max={500} onChange={(value) => setAttribute(`settings.${name}.fontSize`, value)} />
    </div>
    <div className={`${styles['settings-option']} mb-1`}>
      <label className='w-100'>{I18n.t('font_family')}</label>
      <Select
        options={FONT_FAMILY_TYPE.enum.map((o) => ({value: o, label: o}))}
        value={attrs.fontFamily || 'Arial, Helvetica, sans-serif'}
        onChange={(value) => setAttribute(`settings.${name}.fontFamily`, value)}
      />
    </div>
    <div>
      <label>{I18n.t('truncate')}</label>
      <NumberInput
        id={`widget-truncate-${widgetId}`}
        type='number'
        value={attrs.truncate || 1}
        afterChange={(value) => setAttribute(`settings.${name}.truncate`, value)} />
    </div>
    </CollapsibleSection>
  )
}

export default TitleWidgetSettings;
